// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonFields-displayGrid-q0_oX {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    -webkit-column-gap: 12px;
       -moz-column-gap: 12px;
            column-gap: 12px;
}

.CommonFields-dateGridSection-wVAeF {
    display: grid;
    grid-template-columns: repeat(2, 1fr) minmax(110px, 1fr);
    gap: 18px 8px;
}

.CommonFields-specialPriceIcon-nBSZM {
    position: absolute;
    display: inline-block;
    width: 14px;
    margin-left: 4px;
    cursor: pointer;
}

.CommonFields-toolTip-t2pEL {
    position: absolute;
    top: 30px;
    right: 0;
    left: 0px;
    display: none;
    background: var(--primary-white-bg);
    min-width: 280px;
    text-align: center;
    padding: 8px;
    border-radius: 4px;
    color: var(--common-text-color);
    border: 1px solid var(--primary-border);
    font-size: 14px;
    z-index: 2;
}

.CommonFields-specialPriceIcon-nBSZM:hover .CommonFields-toolTip-t2pEL {
    display: block;
}

.CommonFields-toolTipRelativeSection-h8STs::after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: 12px;
    right: 0;
    top: -6px;
    text-align: center;
    background-color: var(--primary-white-bg);
    z-index: 0;
    max-width: 10px;
    max-height: 10px;
    -webkit-transform: rotate(136deg);
    -ms-transform: rotate(136deg);
    transform: rotate(136deg);
    border: 1px solid var(--primary-border);
    border-top-width: 0;
    border-right-width: 0;
}

.CommonFields-faqImage-daioV {
    width: 100%;
    max-width: 14px;
    vertical-align: middle;
    margin-bottom: 3px;
}

.CommonFields-btnGrpBox-kegmX {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    grid-gap: 18px;
    gap: 18px;
}

.CommonFields-userAvatarSection-atZhG {
    margin: 0 auto 24px;
    max-width: 200px;
    text-align: center;
}

@media (max-width:1199px) and (min-width:1024px) {
    .CommonFields-toolTip-t2pEL {
        min-width: 145px;
    }
}

@media (max-width:1023px) and (min-width:768px) {
    .CommonFields-toolTip-t2pEL {
        min-width: 195px;
    }
}

@media screen and (max-width: 767px) {
    .CommonFields-displayGrid-q0_oX {
        grid-template-columns: 100%;
    }

    .CommonFields-dateGridSection-wVAeF {
        grid-template-columns: 100%;
    }

    .CommonFields-toolTip-t2pEL {
        left: -9px;
        min-width: 210px;
        z-index: 18;
    }

}

@media screen and (max-width: 480px) {
    .CommonFields-toolTip-t2pEL {
        left: -100px;
    }

    .CommonFields-toolTipRelativeSection-h8STs::after {
        left: 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CommonFields/CommonFields.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,wDAAwD;IACxD,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,uCAAuC;IACvC,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,mBAAe;QAAf,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAGA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".displayGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    column-gap: 12px;\n}\n\n.dateGridSection {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr) minmax(110px, 1fr);\n    gap: 18px 8px;\n}\n\n.specialPriceIcon {\n    position: absolute;\n    display: inline-block;\n    width: 14px;\n    margin-left: 4px;\n    cursor: pointer;\n}\n\n.toolTip {\n    position: absolute;\n    top: 30px;\n    right: 0;\n    left: 0px;\n    display: none;\n    background: var(--primary-white-bg);\n    min-width: 280px;\n    text-align: center;\n    padding: 8px;\n    border-radius: 4px;\n    color: var(--common-text-color);\n    border: 1px solid var(--primary-border);\n    font-size: 14px;\n    z-index: 2;\n}\n\n.specialPriceIcon:hover .toolTip {\n    display: block;\n}\n\n.toolTipRelativeSection::after {\n    content: '';\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    left: 12px;\n    right: 0;\n    top: -6px;\n    text-align: center;\n    background-color: var(--primary-white-bg);\n    z-index: 0;\n    max-width: 10px;\n    max-height: 10px;\n    -webkit-transform: rotate(136deg);\n    -ms-transform: rotate(136deg);\n    transform: rotate(136deg);\n    border: 1px solid var(--primary-border);\n    border-top-width: 0;\n    border-right-width: 0;\n}\n\n.faqImage {\n    width: 100%;\n    max-width: 14px;\n    vertical-align: middle;\n    margin-bottom: 3px;\n}\n\n.btnGrpBox {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    grid-gap: 18px;\n    gap: 18px;\n}\n\n.userAvatarSection {\n    margin: 0 auto 24px;\n    max-width: 200px;\n    text-align: center;\n}\n\n@media (max-width:1199px) and (min-width:1024px) {\n    .toolTip {\n        min-width: 145px;\n    }\n}\n\n\n@media (max-width:1023px) and (min-width:768px) {\n    .toolTip {\n        min-width: 195px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n\n    .dateGridSection {\n        grid-template-columns: 100%;\n    }\n\n    .toolTip {\n        left: -9px;\n        min-width: 210px;\n        z-index: 18;\n    }\n\n}\n\n@media screen and (max-width: 480px) {\n    .toolTip {\n        left: -100px;\n    }\n\n    .toolTipRelativeSection::after {\n        left: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayGrid": `CommonFields-displayGrid-q0_oX`,
	"dateGridSection": `CommonFields-dateGridSection-wVAeF`,
	"specialPriceIcon": `CommonFields-specialPriceIcon-nBSZM`,
	"toolTip": `CommonFields-toolTip-t2pEL`,
	"toolTipRelativeSection": `CommonFields-toolTipRelativeSection-h8STs`,
	"faqImage": `CommonFields-faqImage-daioV`,
	"btnGrpBox": `CommonFields-btnGrpBox-kegmX`,
	"userAvatarSection": `CommonFields-userAvatarSection-atZhG`
};
module.exports = ___CSS_LOADER_EXPORT___;
